interface vendorInfo {
  fullName: string;
  email: string;
  companyName: string;
  phoneNumber: string;
  employeeID: string;
  // dateOfBirth: string | null;
  position: string;
  address: string | null;
  code: string | null;
  country: string | null;
  addressState: string | null;
  addressCountry: string | null;
}

async function createVendor(vendorInfo: vendorInfo, companyUuid: string) {
  const response = await fetch(
    process.env.REACT_APP_API_URL +
    `${sessionStorage.getItem('businessType') === 'Retail' || sessionStorage.getItem('businessType') === 'WordpressRetail' || sessionStorage.getItem('businessType') === 'OdooRetail' ? 'vendor' : 'hospitality'}/create-vendor?companyUuid=${companyUuid}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      },
      body: JSON.stringify(vendorInfo)
    }
  );
  return response;
}

async function getVendor(vendorid: string) {
  const response = await fetch(
    process.env.REACT_APP_API_URL +
    `${sessionStorage.getItem('businessType') === 'Retail' || sessionStorage.getItem('businessType') === 'WordpressRetail' || sessionStorage.getItem('businessType') === 'OdooRetail' ? 'vendor' : 'hospitality'}/vendor-profile/${vendorid}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );
  const data = await response.json();
  return data;
}

async function updateVendor(vendorDetail: vendorInfo, companyUuid: string, vendorUuid: string) {
  const response = await fetch(
    process.env.REACT_APP_API_URL +
    `${sessionStorage.getItem('businessType') === 'Retail' || sessionStorage.getItem('businessType') === 'WordpressRetail' || sessionStorage.getItem('businessType') === 'OdooRetail' ? 'vendor' : 'hospitality'}/update-vendor?companyUuid=${companyUuid}&clientVendorUuid=${vendorUuid}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      },
      body: JSON.stringify(vendorDetail)
    }
  );
  return response;
}

async function vendorPagination(companyUuid: string, page: Number, limit: Number) {
  const response = await fetch(
    process.env.REACT_APP_API_URL +
    `${sessionStorage.getItem('businessType') === 'Retail' || sessionStorage.getItem('businessType') === 'WordpressRetail' || sessionStorage.getItem('businessType') === 'OdooRetail' ? `vendor?companyUuid=${companyUuid}&` : '/hospitality/vendor-list?'}page=${page}&limit=${limit}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  return response;
}

async function deleteVendor(companyUuid: string, clientVendorUuid: string) {
  const response = await fetch(
    process.env.REACT_APP_API_URL +
    `${sessionStorage.getItem('businessType') === 'Retail' || sessionStorage.getItem('businessType') === 'WordpressRetail' || sessionStorage.getItem('businessType') === 'OdooRetail' ? `vendor/delete-vendor?companyUuid=${companyUuid}&` : `hospitality/delete-vendor?`}clientVendorUuid=${clientVendorUuid}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  return response;
}

export { createVendor, getVendor, updateVendor, vendorPagination, deleteVendor };
